import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import UiInputNumber from '@/modules/ui/components/ui/UiInputNumber.vue';
import Validator from '@/modules/common/utils/validator.ts';

type SchemaInputNumberArgs = SchemaControlArgs & {
  placeholder?: string;
  maxLength?: number;
  min?: number;
  max?: number;
  decimal?: boolean;
};

export class SchemaInputNumber extends SchemaControl<number> {
  readonly component = UiInputNumber;
  readonly placeholder?: string;
  readonly maxLength?: number;
  readonly min?: number;
  readonly max?: number;
  readonly decimal?: boolean;

  constructor(args: SchemaInputNumberArgs) {
    super(args);

    this.placeholder = args.placeholder;
    this.maxLength = args.maxLength;
    this.min = args.min;
    this.max = args.max;
    this.decimal = args.decimal;
    this.setValidators(this.min, this.max);
  }

  private setValidators(min?: number, max?: number) {
    if (typeof min === 'number') {
      this.addValidator(Validator.min(min));
    }

    if (typeof max === 'number') {
      this.addValidator(Validator.max(max));
    }
  }
}
